export default [
  {
    key: 'startTime',
    label: 'label.startTime',
    rules: 'required',
    type: 'time',
    cols: 6,
  },
  {
    key: 'endTime',
    label: 'label.endTime',
    rules: 'required',
    type: 'time',
    cols: 6,
  },
]
